import { BrowserRouter as Router } from 'react-router-dom';
import VersionRouter from './components/VersionRouter';
import { useHotjar } from './helpers/useHotjar';
import { useAmplitude } from './shared/amplitude';

function App() {
  useHotjar();
  useAmplitude();

  return (
    <Router>
      <VersionRouter />
    </Router>
  );
}

export default App;
